import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";

const collections = [
  {
    id: "1",
    tag: "本季强推",
    title: "热血再燃 · 重生逆袭专题",
    desc: "少年归来，剑指巅峰。精选最燃的重生逆袭之作，让你一口气追到停不下来。",
    accent: "bg-primary-600",
    list: comics.filter((c) => c.tags.includes("重生") || c.tags.includes("玄幻") || c.tags.includes("争霸")),
  },
  {
    id: "2",
    tag: "治愈向",
    title: "温柔时光 · 治愈系精选",
    desc: "在快节奏的日子里，让这些暖暖的日常为你卸下疲惫，给心灵充充电。",
    accent: "bg-secondary-600",
    list: comics.filter((c) => c.category === "治愈温馨" || c.category === "搞笑日常"),
  },
  {
    id: "3",
    tag: "烧脑专场",
    title: "谜影重重 · 推理悬疑合集",
    desc: "案中案、局中局，每一个反转都让你直呼过瘾。烧脑爱好者不可错过的专题。",
    accent: "bg-accent-600",
    list: comics.filter((c) => c.category === "悬疑推理"),
  },
  {
    id: "4",
    tag: "星辰大海",
    title: "未来征途 · 科幻机甲专题",
    desc: "跨越星辰、驾驭机甲，感受未来世界的宏大想象与热血冒险。",
    accent: "bg-secondary-700",
    list: comics.filter((c) => c.category === "科幻冒险"),
  },
];

export default function Featured() {
  return (
    <div className="pt-16">
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-4 md:px-6">
          <nav className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600" aria-label="面包屑导航">
            <Link to="/" className="transition-colors hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            <span className="font-medium text-foreground-950">新作专题</span>
          </nav>
        </div>
      </div>

      {/* Hero banner */}
      <section className="relative flex min-h-[340px] items-center overflow-hidden md:min-h-[420px]">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dynamic%20stylized%20manga%20illustration%20of%20many%20comic%20books%20and%20manga%20volumes%20flying%20and%20stacked%20together%20forming%20a%20colorful%20vortex%2C%20warm%20crimson%20gold%20and%20teal%20palette%20with%20ink%20black%20accents%2C%20floating%20pages%20and%20glowing%20panels%2C%20energetic%20comic%20energy%2C%20dramatic%20cinematic%20lighting%2C%20sense%20of%20a%20huge%20curated%20library%20collection%2C%20vibrant%20engaging%20cover%20art%20style%20for%20a%20manga%20special%20features%20banner&width=1600&height=800&seq=featured-hero-mh&orientation=landscape"
            alt="天堂漫画新作专题视觉"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/75 via-foreground-950/40 to-foreground-950/20"></div>
        </div>
        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-16 md:px-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-4 py-1.5 text-sm font-medium text-foreground-950">
            <i className="ri-sparkling-fill"></i> 新作专题企划
          </span>
          <h1 className="mt-4 max-w-xl font-heading text-3xl font-black leading-tight text-background-50 md:text-4xl">
            按主题，把好作品一次给你
          </h1>
          <p className="mt-4 max-w-xl text-base text-background-100">
            天堂漫画团队从全库完整书库中精挑细选，按题材与风格策划多个专题，帮你在海量资源全收录中快速找到对味的那一部。
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="space-y-16">
          {collections.map((col) => (
            <section key={col.id}>
              <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
                <div className="flex items-start gap-3">
                  <span className={`mt-1 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${col.accent} text-2xl text-background-50`}>
                    <i className="ri-star-smile-fill"></i>
                  </span>
                  <div>
                    <span className="flex items-center gap-2 text-sm font-medium text-primary-600">
                      <i className="ri-fire-fill"></i> {col.tag}
                    </span>
                    <h2 className="mt-1 font-heading text-xl font-black text-foreground-950 md:text-2xl">{col.title}</h2>
                    <p className="mt-1.5 max-w-2xl text-sm text-foreground-600">{col.desc}</p>
                  </div>
                </div>
              </div>
              <div className="mt-7 grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 lg:grid-cols-4 md:gap-6">
                {col.list.slice(0, 4).map((c) => (
                  <ComicCard key={c.id} comic={c} />
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}